export default "__VITE_ASSET__CigwRjdb__"